import React, {FC} from 'react';
import {Typography, TypographyProps} from "@material-ui/core";
import {getFullName} from "../../../utils";
import {Skeleton} from "@material-ui/lab";
import {useWorker} from "../redux/workers.hook";

interface WorkerDisplayProps {
    workerId?: string;
    typographyProps?: TypographyProps;
}

export const WorkerDisplay: FC<WorkerDisplayProps> = ({workerId, typographyProps}) => {

    const {worker} = useWorker(workerId);

    return (
        <Typography variant="inherit" {...typographyProps}>
            {workerId && worker ? `${getFullName(worker)}` : <Skeleton width={150}/>}
        </Typography>
    )
}